import React from "react";

import { DOCUMENT_TYPES, ICONS } from "../../common/constants";
import Button from "../Button";
import Col from "../Col";
import File from "../File";
import Form, { Heading } from "../Form";
import Icon from "../Icon";
import Input from "../Input";
import Row from "../Row";
import Textarea from "../Textarea";
import Tile from "../Tile";
import Toast from "../Toast";

import { selectFndFormData } from "../../store/selectors/fndForm";
import { setFndFormData, clearFndFormData } from "../../store/actions/fndForm";
import { upload } from "../../helpers/uploadDocument";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import Loader from "../Loader";
import { selectFormLoader } from "../../store/selectors/FormLoader";
import { clearValidation } from "../../store/actions/validation";
import { selectValidation } from "../../store/selectors/Validation";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CheckBox from "../Checkbox";
import { variables } from "../../Tenants";
import { onUrlImageExtensionExist } from "../../helpers/CommonHelpers";
import { isDisabled } from "./validation";
import { shouldBeAn, titleCase } from "../../common/textUtils";

class DocumentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonPressed: "",
      errorMessage: "",
      documentTypes: [],
    };
  }
  componentDidMount() {
    const { setFndFormData, from, user } = this.props;

    setFndFormData({ docAvailablity: false });
    if (!(from === "Service Request" || from === "Contact")) {
      setFndFormData({ isImportantDocument: false });
    }

    if (
      from === "Service Request" &&
      user.roles[0].role.name === "Home Owner"
    ) {
      this.setState({ documentTypes: ["Image"] });
      this.onSelectDocumentType("Image");
    } else {
      this.setState({ documentTypes: DOCUMENT_TYPES });
    }
  }
  saveDoc = (fndForm) => {
    const { onSaveDocument } = this.props;
    onSaveDocument(fndForm);
  };
  componentDidUpdate() {
    const {
      validation,
      onClose,
      clearFndFormData,
      clearValidation,
      setFndFormData,
      from,
    } = this.props;
    if (validation.status === true) {
      if (
        validation.message === "FaqDocNotes" &&
        this.state.buttonPressed === "SaveAndClose"
      ) {
        onClose();
        clearFndFormData();
        clearValidation();
      } else if (
        validation.message === "FaqDocNotes" &&
        this.state.buttonPressed === "SaveAndAdd"
      ) {
        clearFndFormData();
        clearValidation();
        if (!(from === "Service Request" || from === "Contact")) {
          setFndFormData({ isImportantDocument: false });
        }
      }
    }
  }
  async onSelectDocument(file) {
    try {
      if (file && file.length > 0) {
        let path = file[0].path;
        if (onUrlImageExtensionExist(path)) {
          this.props.setFndFormData({ image: file, uploadType: "Image" });
        } else {
          // Show the initial "upload started" toast with a unique ID.
          const uploadStartToastId = toast.success(
            "Your document upload has started, it may take some time.",
            {
              autoClose: 5000,
              position: "top-center",
              toastId: "upload-start", // Adding a unique ID.
            },
          );

          try {
            let newFileName =
              path.split(/\.(?=[^\.]+$)/)[0] +
              moment().format("MMDDYYYYhmmss") +
              "." +
              path.split(/\.(?=[^\.]+$)/)[1];
            let image = await upload(file[0], newFileName.replace(/ /g, ""));

            // Check if upload returned a valid URL.
            if (!image) {
              toast.dismiss(uploadStartToastId);
              throw new Error("Upload failed to return a valid URL");
            }

            this.props.setFndFormData({ image: image, uploadType: "Doc" });
          } catch (uploadError) {
            // Dismiss the success toast if there's an error.
            toast.dismiss(uploadStartToastId);
            throw uploadError;
          }
        }
        this.setState({ errorMessage: "" });
      } else {
        let documentType = this.props.fndForm.type;
        let errorMessage = this.state.errorMessage;
        if (documentType === "Warranty" || documentType === "Owners Manual") {
          toast.error(
            " 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG.",
            { autoClose: 12000, position: "top-center" },
          );
          errorMessage =
            "You have uploaded an invalid file format, allowed formats are DOC,PDF";
        } else if (documentType === "Image") {
          toast.error(
            " 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG.",
            { autoClose: 12000, position: "top-center" },
          );
          errorMessage =
            "You have uploaded an invalid file format, allowed formats are JPG,PNG";
        } else if (documentType === "Invoice") {
          toast.error(
            " 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG.",
            { autoClose: 12000, position: "top-center" },
          );
          errorMessage =
            "You have uploaded an invalid file format, allowed formats are PDF";
        } else if (documentType === "Spreadsheet") {
          toast.error(
            " 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG.",
            { autoClose: 12000, position: "top-center" },
          );
          errorMessage =
            "You have uploaded an invalid file format, allowed formats are SHEET,PPT";
        } else if (documentType === "Contract") {
          toast.error(
            " 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG.",
            { autoClose: 12000, position: "top-center" },
          );
          errorMessage =
            "You have uploaded an invalid file format, allowed formats are PDF,JPG,PNG,DOC,DOCX";
        }
        this.setState({ errorMessage });
      }
    } catch (e) {
      console.error("Document upload error:", e);
      toast.error(
        "Something went wrong with the document upload. Please try again.",
        {
          autoClose: 5000,
          position: "top-center",
          toastId: "upload-error", // Adding a unique ID
        },
      );
    }
  }

  onSelectDocumentType(documentType) {
    const { setFndFormData } = this.props;
    setFndFormData({ type: documentType });
    this.setState({ errorMessage: "" });
  }

  render() {
    const {
      onClose,
      breadcrumb,
      fndForm,
      setFndFormData,
      loader,
      from,
      user: { roles },
    } = this.props;

    const headline = `Add ${shouldBeAn(fndForm.type || "Document")} ${titleCase(
      fndForm.type || "Document",
    )}`;

    const { documentTypes } = this.state;
    return (
      <Form
        headline={headline}
        onClose={onClose}
        onSubmit={() => this.saveDoc(fndForm)}
        actions={
          <>
            {loader ? <Loader center={true} /> : null}
            <Button
              color="semantic"
              size="small"
              label="Save and Add Another"
              onClick={() =>
                this.setState({
                  buttonPressed: "SaveAndAdd",
                })
              }
              disabled={isDisabled(
                fndForm,
                from === "Service Request"
                  ? ["image"]
                  : ["name", "image", "description"],
              )}
            />
            <Button
              color="teal"
              size="small"
              label="Save Document"
              onClick={() =>
                this.setState({
                  buttonPressed: "SaveAndClose",
                })
              }
              disabled={isDisabled(
                fndForm,
                from === "Service Request"
                  ? ["image"]
                  : ["name", "image", "description"],
              )}
            />
          </>
        }
        component={
          <>
            <Row chonky>
              {documentTypes.length > 1 && (
                <Col chonky xs="12" md="6">
                  {breadcrumb && (
                    <>
                      <Toast
                        message={`You are adding a document to ${breadcrumb}.`}
                      />
                      <br />
                      <br />
                    </>
                  )}
                  <Heading>Document Type</Heading>
                  <Row granola>
                    {documentTypes.map((documentType, i) => (
                      <Col granola key={i} md="4" xs="6">
                        <Tile
                          icon={
                            <Icon
                              weight="light"
                              glyph={
                                ICONS[
                                  documentType === "General"
                                    ? "OtherDoc"
                                    : documentType
                                ]
                              }
                            />
                          }
                          onClick={() =>
                            this.onSelectDocumentType(documentType)
                          }
                          active={documentType === fndForm.type}
                          title={documentType}
                          size="small"
                        />
                      </Col>
                    ))}
                  </Row>
                </Col>
              )}

              <Col chonky xs="12" md={documentTypes.length > 1 ? "6" : "12"}>
                {fndForm.type === "Video" ? (
                  <File
                    label="Document"
                    documentType={fndForm.type}
                    onSelect={(file) => this.onSelectDocument(file)}
                    files={
                      fndForm.uploadType === "Doc"
                        ? []
                        : fndForm.image
                          ? fndForm.image
                          : []
                    }
                    image={null}
                    errors={this.state.errorMessage}
                    required={true}
                  />
                ) : (
                  <File
                    label={fndForm.type || "Document"}
                    documentType={fndForm.type}
                    onSelect={(file) => this.onSelectDocument(file)}
                    files={
                      fndForm.uploadType === "Doc"
                        ? []
                        : fndForm.image
                          ? fndForm.image
                          : []
                    }
                    image={null}
                    errors={this.state.errorMessage}
                    required={true}
                  />
                )}
                {/* Here is the broken JSX */}
                {fndForm.uploadType === "Doc" ? (
                  <a href={fndForm.image} target="_blank">
                    <label style={{ paddingBottom: 5 }}>
                      {fndForm.image?.split(".com/")[1]}
                    </label>
                  </a>
                ) : null}
                {fndForm.type === "Video" ? (
                  <div>
                    <div
                      style={{
                        textAlign: "center",
                        color: "#43467F",
                        fontWeight: 700,
                      }}
                    >
                      {" "}
                      (OR)
                    </div>
                    <Textarea
                      value={fndForm.Embed}
                      onChange={(e) =>
                        setFndFormData({ Embed: e.target.value })
                      }
                      label="Embed "
                      block
                      type="media"
                    />
                  </div>
                ) : null}
                {!(
                  this.props.from === "Service Request" &&
                  roles[0].role.name === "Home Owner"
                ) && (
                  <>
                    <Input
                      value={fndForm.name}
                      onChange={(e) => setFndFormData({ name: e.target.value })}
                      label={`${fndForm.type || "Document"} Name`}
                      placeholder={`${fndForm.type || "Document"} Name`}
                      block
                      required={false}
                    />
                    <Textarea
                      value={fndForm.description}
                      onChange={(e) =>
                        setFndFormData({ description: e.target.value })
                      }
                      label="Description"
                      placeholder="Description"
                      block
                      required={false}
                    />
                  </>
                )}
                {this.props.from === "propertyForm" && (
                  <CheckBox
                    checked={fndForm.docAvailablity}
                    value={fndForm.docAvailablity}
                    label={`Make it available at ${variables.suite} level `}
                    onChange={(e) =>
                      setFndFormData({
                        docAvailablity: !fndForm.docAvailablity,
                      })
                    }
                  />
                )}
                {!(from === "Service Request" || from === "Contact") && (
                  <CheckBox
                    checked={fndForm.isImportantDocument}
                    value={fndForm.isImportantDocument}
                    label={`Important Document`}
                    onChange={(e) =>
                      setFndFormData({
                        isImportantDocument: !fndForm.isImportantDocument,
                      })
                    }
                  />
                )}
              </Col>
            </Row>
          </>
        }
      />
    );
  }
}
const mapStateToProps = (state) => ({
  fndForm: selectFndFormData(state),
  loader: selectFormLoader(state),
  validation: selectValidation(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFndFormData,
      clearFndFormData,
      clearValidation: clearValidation,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentForm);
